
import React, { Component } from 'react';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import APIService from '../Services/APIService/apiService';
import { Button, Badge } from 'reactstrap';
import {  Redirect } from 'react-router-dom';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class EasyScheduling extends Component{

    constructor(props){
        super(props);
        this.state = {
            APIName: "Easy Scheduling",
            APIUser: "",
            APIPass: "",
            TenantID: "",
            loadingEasy: false,
            type: 'password',
            isAutenticated: true

        };
        this.handleApiUser = this.handleApiUser.bind(this);
        this.handleApiPass = this.handleApiPass.bind(this);
        this.handleTenantID = this.handleTenantID.bind(this);
        this.showHide = this.showHide.bind(this);
    }  
    showHide(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          type: this.state.type === 'input' ? 'password' : 'input'
        })  
    }

    componentDidMount(){

        var EasySchedulingList = this.props.DataEasyScheduling;

        var easy = EasySchedulingList.find(x=> x.ALIAS === this.state.APIName);  
        var easyValue = JSON.parse(easy.VALUE);
        var UserName = easyValue.UserName === null || easyValue.UserName === undefined   ? "" :  easyValue.UserName;
        var Pass = easyValue.Password === null || easyValue.Password === undefined   ? "" :  easyValue.Password;
        var TenantID = easyValue.TenantID === null || easyValue.TenantID === undefined   ? "" :  easyValue.TenantID;

        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = UserName;
        stateCopy.APIPass = Pass;
        stateCopy.TenantID = TenantID;
        this.setState(stateCopy);
    }

    handleApiUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = value;
        this.setState(stateCopy);    
    }
    handleApiPass(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIPass = value;
        this.setState(stateCopy);    
    }
    handleTenantID(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.TenantID = value;
        this.setState(stateCopy);    
    }

    ValidateSaveEasyScheduling(){

        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var TenantID = this.state.TenantID;

        if(UserName === null || UserName === "" || UserName === undefined)
        {
            toast.error("Client API User field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(Pass === null || Pass === "" || Pass === undefined)
        {
            toast.error("Client API Password field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(TenantID === null || TenantID === "" || TenantID === undefined)
        {
            toast.error("TenantID field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        return true;
    }
    SaveEasyScheduling(e){
        e.preventDefault();    
        var email = sessionStorage.getItem('email');
        var that = this;
        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var TenantID = this.state.TenantID;
        var CompanyCode = this.props.CompanyCode;
        var EasyApiUser = null;
        var EasyApiPassword = null;

        var EasySchedulingList = this.props.DataEasyScheduling;
        var easy = EasySchedulingList.find(x=> x.ALIAS === this.state.APIName);   

        var Validate = this.ValidateSaveEasyScheduling();
        if(Validate === false)
        {
            return false;
        }        
        this.setState({
            loadingEasy: true
        });

        var result = APIService.SaveEasySchedulingSetting(CompanyCode, email, UserName, Pass, TenantID, EasyApiUser, EasyApiPassword);
        result.then(function(data){
            if(data.data === "OK"){
                that.setState({
                    loadingEasy: false
                });

                var newList = {
                    ALIAS: easy.ALIAS,
                    COMPANY_CODE: CompanyCode,
                    ID: easy.ID,
                    NAME: easy.NAME,
                    VALUE: {
                        UserName: UserName,
                        Password: Pass,
                        TenantID: TenantID
                    }
                };
                that.props.SetObject(newList);

                toast.success("Saved!", { className: {
                    opacity: 0.8
                }});            
            }else if(data.data === "NoExist"){
                that.setState({
                    loadingEasy: false
                });  
                toast.error("API Setting dosen't exist!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "Empty"){
                that.setState({
                    loadingEasy: false
                });                
                toast.error("Not Exist!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {

            that.setState({
                loadingEasy: false,
            });      
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });        
    }   
    render(){      

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }

        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar/>
                    <div className="card-body" style={{ height: "600px", 'overflowY': 'scroll'}}>
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Name</label>
                            </div>   
                            <div className="col-2">
                                    <input style={{ 'marginTop': '10px' }} className="form-control" name="name" id="name" type="text" value={ this.state.APIName} readOnly/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API User(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="clientapiuser" id="clientapiuser" type="text" onChange={this.handleApiUser}  value={ this.state.APIUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API Password(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="clientapipass" id="clientapipass"type={this.state.type} onChange={this.handleApiPass }   value={ this.state.APIPass}/>
                            </div>
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHide}>{this.state.type === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                            
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>TenantID(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="companycode" id="companycode" type="text" onChange={this.handleTenantID } value={ this.state.TenantID}/>
                            </div>                          
                       </div>
                       <div className="row">             
                            <div className="col-2 offset-10" style={{ 'paddingTop': '280px'}} size="sm">
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#33B5E5'}
                                    loading={this.state.loadingEasy}
                                />
                                {
                                    this.state.loadingEasy
                                    ?
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveEasyScheduling(e)} disabled>Save</Button>
                                    : 
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveEasyScheduling(e)}>Save</Button>
                                }
                               
                            </div>                             
                       </div>
                   </div>
                </div>
            </div>            
        );
    }
}

export default EasyScheduling;


// WEBPACK FOOTER //
// ./src/APIComponent/EasyScheduling.jsx